export default {
  country_locale: 'uk-UA',
  wia_title: 'Почнемо з продукту',
  wia_need_help: 'Чи потрібна допомога?',
  wia_model_name: 'Назва моделі',
  wia_back: '<Змінити',
  wia_confirm: 'Надіслати',
  wia_issue_title: 'В чому проблема?',
  wia_issue_concern: 'В чому проблема?',
  wia_issue_specific: 'Специфічний вид проблеми',
  wia_possible_solution: 'Можливі рішення',
  wia_solved_issue: 'Ви вирішили проблему?',
  wia_closed: 'Закрий це',
  wia_feedback_ok: ' Так',
  wia_find_another_solution: 'Знайдіть інше рішення',
  wia_feedback_title: 'Ми раді, що проблему вдалося вирішити!',
  wia_feedback_text1: 'Відвідайте наш магазин і дізнайтеся про спеціальні пропозиції',
  wia_feedback_text2: 'Дізнайтеся більше про наші новітні розумні технології!',
  wia_smile_up_popup_text1: 'Ознайомтеся з нашим планом гарантії',
  wia_smile_down_popup_title: 'Вам ще потрібна допомога?',
  wia_smile_down_popup_text1: 'Перейдіть до другого кроку',
  wia_smile_down_popup_or_text: 'чи',
  wia_smile_down_popup_text2: 'Замовити виклик',
  wia_need_more_help: 'Вам ще потрібна допомога?',
  wia_optional_label: '(Необов\'язково)',
  wia_no_solution: 'Ми не змогли знайти швидке рішення, але не хвилюйтеся, ми все одно можемо вам допомогти. Натисніть тут, щоб отримати доступ до технічної підтримки.',
  wia_all_solution: 'Всі рішення',
  wia_all_categories: 'Всі категорії',
  wia_seo_l1_issue: 'Усі проблеми',
  wia_seo_wp_country_name: '',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: '',
  wia_seo_id_country_name: 'UA',
  wia_seo_wp_meta_title: 'Проблеми та рішення',
  wia_seo_bk_meta_title: 'Проблеми та рішення',
  wia_seo_hp_meta_title: 'Проблеми та рішення',
  wia_seo_id_meta_title: 'Проблеми та рішення',
  wia_seo_wp_meta_description: 'Вирішуйте проблеми, пов’язані з вашою технікою, всього за кілька кліків за допомогою онлайн-технічної допомоги Whirlpool Україна',
  wia_seo_bk_meta_description: 'Вирішуйте проблеми, пов’язані з вашою технікою, всього за кілька кліків за допомогою онлайн-технічної допомоги Bauknecht Україна',
  wia_seo_hp_meta_description: 'Вирішуйте проблеми, пов’язані з вашою технікою, всього за кілька кліків за допомогою онлайн-технічної допомоги Hotpoint Україна',
  wia_seo_id_meta_description: 'Вирішуйте проблеми, пов’язані з вашою технікою, всього за кілька кліків за допомогою онлайн-технічної допомоги Indesit Україна',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
